import { HTTP } from '@/services/axios';

export async function getComponentOptions(){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: '/app/core/Component/getComponentOptions.php'
    })
    .then(response => {
        result = response.data;
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}